import { HTMLAttributes } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { wacToken } from "@/libraries/design/foundations/index.ts";

export interface HeadProps extends HTMLAttributes<HTMLTableSectionElement> {
    stickyOffset?: number;
}
export const Head = (props: HeadProps) => {
    const { stickyOffset } = props;
    return (
        <thead
            {...props}
            css={[headCss]}
            // compiled-css does not support dynamic styling from props
            style={
                stickyOffset === undefined
                    ? {}
                    : {
                          top: stickyOffset,
                          position: "sticky"
                      }
            }
        />
    );
};

export const HeadRow = (props: HTMLAttributes<HTMLTableRowElement>) => {
    return <tr {...props} css={headRowCss} />;
};

export interface HeadCellProps extends HTMLAttributes<HTMLTableCellElement> {
    id?: string;
}

export const HeadCell = (props: HeadCellProps) => {
    const scope = props.role === "presentation" ? undefined : "col";
    return <th {...props} css={headCellStyles} scope={scope} />;
};

const headCss = css({
    "borderBlockEnd": `solid 1px ${wacToken("color.neutral.light400")}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "th:last-of-type": {},
    [media.below.sm]: {
        display: "none"
    },

    "zIndex": 1,
    "background": wacToken("color.neutral.light0")
});

const headRowCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "th:first-of-type": {
        textTransform: "uppercase",
        textAlign: "start"
    }
});

const headCellStyles = css({
    "justifyContent": "space-between",
    "fontWeight": 400,
    "textAlign": "left",
    "color": wacToken("color.primary.black"),
    [media.below.sm]: {
        display: "flex",
        padding: "12px 14px"
    },
    "display": "table-cell",
    "padding": "14px",
    "borderInlineEnd": `1px solid ${wacToken("color.neutral.light400")}`,
    ":last-of-type": {
        borderInlineEnd: "none"
    }
});
